import { type OrderChannel } from '../../../../../../machine';
import { type FeaturedUpsellProduct } from './bag-featured-upsell.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export type BagFeaturedUpsellContext = {
  sessionInterval: number;
  restaurantId: string | undefined;
  orderChannel: OrderChannel;
  productLineageKey: string;
  hasAnimationImage: boolean;
  cartProductIds: string[];
  canShowUpsells: boolean;
  isReduceMotionEnabled: boolean;
  product: FeaturedUpsellProduct | undefined;
};

export const initialContext: BagFeaturedUpsellContext = {
  sessionInterval: 0,
  restaurantId: undefined,
  orderChannel: 'pickup',
  productLineageKey: '',
  hasAnimationImage: false,
  cartProductIds: [],
  canShowUpsells: false,
  isReduceMotionEnabled: false,
  product: undefined,
};
